import {gql} from "@irati/utils/gql"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import fullBasketBreakdown from "../fragments/basketTotalWithBreakdown"

const query = gql`
  query CheckoutTotalPrice($items: [BasketInputItem!]!, $paymentDetails: BasketPaymentDetailsInput) {
    checkoutTotals(items: $items, paymentDetails: $paymentDetails) {
      ...fullBasketBreakdown
    }
  }
  ${fullBasketBreakdown}
`

export const checkoutTotalsKey = getQueryNames(query)[0]

export default query
